import { render, staticRenderFns } from "./MainStep.vue?vue&type=template&id=2c9a0528"
import script from "./MainStep.vue?vue&type=script&lang=js"
export * from "./MainStep.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports